import React from 'react';
import { meetings } from '../data/mockData';

function Meetings() {
  return (
    <div className="bg-white rounded-lg shadow p-4">
      <h2 className="text-xl font-semibold text-green-800 mb-4">วาระประชุม</h2>
      <div className="space-y-3">
        {meetings.map((meeting) => (
          <a
            key={meeting.id}
            href={meeting.url}
            className="block p-3 border rounded-md hover:bg-green-50"
          >
            <div className="flex items-start space-x-3">
              <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                <span className="text-green-800">📋</span>
              </div>
              <div className="flex-1">
                <span className="text-gray-800 hover:text-green-800">
                  {meeting.title}
                </span>
              </div>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
}

export default Meetings; 